import React, { useState, useEffect } from "react";
import "react-bootstrap-accordion/dist/index.css";
import axios from "axios";
import MaterialTable from "material-table";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import ContentLoader from "react-content-loader";
import { ABS } from "@formulajs/formulajs";
import { toast } from "react-toastify";
import moment from "moment";

import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";
import AuthService from '../../../services/auth.service'
import AddExitingPayment from "./addUserPayment";
import { set } from "immutable";

function NewPaymentScreen() {
  // let navigate = useNavigate()
  const [companydata, setCompany] = useState([]);
  const [pacakge, setPackage] = useState([]);
  const [data, setData] = useState([]);
  const [planData, setPlanData] = useState([]);
  const [plan, setPlan] = useState("");
  const [userallow, setUserallow] = useState();
  const [adduser, setAdduser] = useState(false);
  const [upgrade, setUpgrade] = useState(false);
  const [companyId, setCompanyId] = useState("");
  const [amount, setAmount] = useState(0);
  const [value, setValue] = useState("");
  const [user, setUser] = useState([]);
  const [user_email, setUser_email] = useState('')
  const [end_date, setEnd_date] = useState("");
  const [start_date, setStart_date] = useState("");
  const [renewal, setRenewal] = useState("");
  const [changeuser, setChangeUser] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [session_id, setSession_id] = useState("");
  const [planCheck, setplanCheck] = useState("");
  const [createDate, setCreateDate] = useState("");
  const [subscriptionsstatus, setSubscriptionStatus] = useState("");
  const [trialEnd, setTrialEnd] = useState("");
  const [Sub_Trial_Days, setSub_Trial_Days] = useState(0);
  const [trialDaysValue, setTrialDaysValue] = useState(0);
  const [payment_intent_id, setPayment_intent_id] = useState('')
  const activeSub = (data && data.length > 0) 
  ? data.find(sub => sub.status === "success" || sub.status === "pending" || sub.status === "Success") : null;
  const totalUsersAllowed = activeSub 
  ? (activeSub.no_of_users || activeSub.no_of_user) 
  : (companydata.userallow || 0);
  const registeredUsersCount = user.length;
  const registeredPercentage = totalUsersAllowed > 0 
  ? Math.min((registeredUsersCount / totalUsersAllowed) * 100, 100) 
  : 0;

  let navigate = useNavigate();

  const company = () => {
    GetCompanyInfoService.getCompanyInfo().then((response) => {
      setCompany(response.data);
    })
  };

  const packagedata = async () => {
    const res = await fetch(API + "company/packages/", {
      headers: authHeader(),
    });
    const getcon = await res.json();
    setPackage(getcon);
  };

  const dateDifferenceInDays = (date1, date2) => {
    const start = new Date(date1);
    const end = new Date(date2);
    const diffInMilliseconds = Math.abs(start - end);
    return Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
  };

  const handlePaymentData = async () => {
    setIsLoading(true); 
    try {
        const res = await axios.get(API + "paymentsub/subscription/", { headers: authHeader() });
        
        setSession_id(res.data.data.id);

        if (res.data.success === 1) {
            const response = await axios.get(
                API + `paymentsub/subscription/payment-id/?subscription_id=${res.data.data.id}`, 
                { headers: authHeader() }
            );
            
            setData(response.data.data); 
        }
    } catch (error) {
        console.error("Error fetching payment data:", error);
    } finally {
        setIsLoading(false); 
    }
};

  const getViewUser = async () => {
    await axios
      .get(API + "company/users/", {
        headers: authHeader(),
      })
      .then((res) => {
        setUser(res.data);
      })
  };

  useEffect(() => {
    // setUserallow(companydata.userallow);
    setCompanyId(companydata.id);
  }, [companydata]);

  useEffect(() => {
    handlePaymentData();
    getViewUser();
  }, []);

  const calculateMonthsBetweenDates = (date1, date2) => {
  if (!date1 || !date2) return 0;
  const dateObj1 = new Date(date1); 
  const dateObj2 = new Date(date2);

  if (isNaN(dateObj1) || isNaN(dateObj2)) return 0;
  const yearDiff = dateObj2.getFullYear() - dateObj1.getFullYear();
  const monthDiff = dateObj2.getMonth() - dateObj1.getMonth();

  const totalMonths = yearDiff * 12 + monthDiff;

  return Math.max(0, totalMonths);
};

  // useEffect(() => {
  //   const currentDate = new Date(); // Current date
  //   const endDate = new Date(end_date); // End date of the plan
  //   const remainingMonths = Math.max(0, endDate.getMonth() - currentDate.getMonth() + (12 * (endDate.getFullYear() - currentDate.getFullYear())));
  //   const userAllows = parseInt(userallow);
  //   const totalMonths = 12; // Total number of months in a year

  //   const newAmount = userAllows * 100 * remainingMonths / totalMonths;

  //   console.log("newAmount", newAmount)

  //   setPlan(planData.map((val) => val.plan));
  //   setAmount(newAmount);
  // }, [planData, userallow, end_date]);

  useEffect(() => {
    company();
    packagedata();
  }, [data]);

  const trial_periodvalue = pacakge.filter((value) => value.name === 'Annual')[0]?.trial_period

  useEffect(() => {
  if (!start_date) return;

  const currentDate = moment();
  const formattedDate = currentDate.format("YYYY-MM-DD");
  
  const daysSinceStart = dateDifferenceInDays(formattedDate, start_date);
  
// if (amount === 0) {
//   setplanCheck("Free Plan");
// } else if (Sub_Trial_Days > 0 ) {
//   setplanCheck("Trial");
// } else {
// // Your Plan - Annual , Monthly , etc 
//   setplanCheck(companydata?.plan ? `${companydata.plan} Plan` : "Paid Plan");
// }
  const calculatedDate = moment(start_date).add(Sub_Trial_Days, 'days').toDate();
  
  const formattedTrialEnd = Helper.DateNormal(calculatedDate);
  
  setTrialEnd(formattedTrialEnd);
  
}, [start_date, Sub_Trial_Days, amount, companydata]);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const response = await fetch(API + "company/profile", {
          headers: authHeader(),
        });
        const companyInfo = await response.json();
        setCompany(companyInfo);
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    };

    // Fetch user data
    const fetchUserData = async () => {
      try {
        const response = await axios.get(API + "company/users", { headers: authHeader() });
        const users =  response.data;
        setUser(users);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchCompanyData();
    fetchUserData();
  }, []);

  const handleCancel = () => {
    const id = companydata.user;
    // axios.post(API + 'accounting/stripesubscriptioncancel/', { session_id: data ? data.payment_id : "" }
    // axios.delete(API + `company/customeruseractivate/${id}/`,
    axios
      .post(
        API + "paymentsub/canceltrial-subscription/",
        {
          user_email: companydata.user_email,
          subscription_id: session_id,
          payment_intent_id: payment_intent_id
        },
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        toast.success(`${res.data.message}`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          // closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setTimeout(() => {
          AuthService.logout()
            .then(() => {
              navigate("/");
            })
        }, 1000);
        // axios
        //   .delete(API + `company/usersubscriptiondelete/${id}/`, {
        //     headers: authHeader(),
        //   })
        //   .then((response) => {
        //     AuthService.logout()
        //       .then(() => {
        //         navigate("/");
        //       })
        //       .catch((error) => {
        //         console.error("Logout error:", error);
        //       });
        //   });
        // if (response.data.success === 1) {
        //   const userid = localStorage.getItem("userid")
        //   const companyid = localStorage.getItem("companyid")

        //   const body = {
        //     company: companyid,
        //     user: userid,
        //     transaction_id: '',
        //     payment_id: response.data.response.id,
        //     payment_type: '',
        //     mode_of_payment: '',
        //     amount: (response.data.response.items.data[0].price.unit_amount_decimal * response.data.response.items.data[0].quantity) / 100,
        //     sub_total: (response.data.response.items.data[0].price.unit_amount_decimal * response.data.response.items.data[0].quantity) / 100,
        //     tax: 0,
        //     total: 0,
        //     status: response.data.response.cancel_at_period_end ? 'cancelled' : 'active',
        //     ip_address: '',
        //     start_date: Helper.DatePicker(new Date(response.data.response.start_date * 1000)),
        //     end_date: response.data.response.cancel_at ? Helper.DatePicker(new Date(response.data.response.cancel_at * 1000)) : null,
        //     plan: 'Annual',
        //     updated_at: (response.data.response.cancel_at),
        //   };
        //   paymentcreateupdate(body)
        // }
      });
  };

  const ActiveSubscriptioncancel = () => {
    // axios.post(API + 'accounting/stripesubscriptioncancel/', { session_id: data ? data.payment_id : "" }
    // axios.delete(API + `company/customeruseractivate/${id}/`,
    axios
      .post(
        API + "accounting/stripesubscriptioncancel/",
        {
          session_id: session_id,
        },
        {
          headers: authHeader(),
        }
      ).then((res) => {
        if (res.data.success === 1) {

          toast.success("Successfully cancelled")
        }
        else {
          // toast.error("Something went wrong, Please log a support ticket or send email to support@athenafintech.com")
        }
      })
  }

  const handleCancelSub = () => {
    // if (subscriptionsstatus === "Active") {

    //   confirmAlert({
    //     title: "",
    //     message: `Your subscription for ${companydata ? companydata.company_name : ""
    //       } licenses expires on ${end_date}. Please confirm you want to cancel your subscription on expiration date. On confirmation, no further subscription charges will be applied after expiration date. Athena Fintech is not responsible for maintaining your data after the expiration date.`,
    //     buttons: [
    //       {
    //         label: "Confirm",
    //         onClick: () => {
    //           ActiveSubscriptioncancel();
    //         },
    //       },
    //       {
    //         label: "No",
    //       },
    //     ],
    //   });
    // }
    // else {
    confirmAlert({
      title: "",
      message: `Your subscription for ${companydata ? companydata.company_name : ""
        } licenses expires on ${end_date}. Please confirm you want to cancel your subscription on expiration date. On confirmation, no further subscription charges will be applied after expiration date. Athena Fintech is not responsible for maintaining your data after the expiration date.`,
      buttons: [
        {
          label: "Confirm",
          onClick: () => {
            handleCancel();
          },
        },
        {
          label: "No",
        },
      ],
    });
    // }
  };

  const getsubscription = async () => {
    try {
        const response = await axios.get(API + 'paymentsub/subscription/', {
            headers: authHeader(),
        });
        const subData = response.data?.data;
        console.log("Subdata",subData)
        console.log("Response data",response.data)
        if (subData) {
        const days = parseInt(subData.trial_days) || 0;
        const amt = parseFloat(subData.plan?.per_user_amount) || 0;
        setAmount(amt);
        setTrialDaysValue(days);
        setSub_Trial_Days(days);
        setPlan(subData.plan?.plan_name);
        setEnd_date(subData.end_date);
        // setTrialEnd(subData.end_date);
        setStart_date(subData.start_date);
        setRenewal(subData.renewal_date);
        setCreateDate(subData.created_at);
        setUserallow(subData.no_of_users);
        setPayment_intent_id(subData.intent_id);
        // console.log(subData.total_amount, "status");
        
        }
      } catch (error) {
        console.error("Error fetching subscription:", error);
        setIsLoading(false);
    }
};

  

  useEffect(() => {
    getsubscription()
    // console.log(trialEnd);
    // console.log(subData.plan.plan_name, "plan");
  }, [])

  console.log("Amount,",amount)
  console.log("Plan,",plan)


  // const totalUsersAllowed = activeSub ? activeSub.no_of_users : 0;
  // const registeredUsersCount = user.length;
  // const registeredPercentage = totalUsersAllowed > 0 
  // ? Math.min((registeredUsersCount / totalUsersAllowed) * 100, 100) 
  // : 0;

  return (
    <>
      {isLoading !== true ? (
        <div className="container-fluid pt-3">
          <div>
            {" "}
            <p className="h2 text-center mb-2">
              {value === "addUser" ? "Existing Plan" : "Plan"}
            </p>{" "}
          </div>{" "}
          <div className="row mt-3">
            {" "}
            {(value === "addUser" && adduser) ||
              (value === "upgrade" && upgrade) ? (
              <AddExitingPayment
                userallowed={userallow}
                companyid={companyId}
                planData={planData}
                companydata={companydata}
                setAdduser={setAdduser}
                setCompany={setCompany}
                setUpgrade={setUpgrade}
                adduser={adduser}
                upgrade={upgrade}
                value={value}
                paymentid={session_id}
                end_date={end_date}
              />
            ) : (
              <div class="container mb-5">
                <div class="row justify-content-center">
                  <div class="col-sm-6">
                    {/* <div class="card">
                        <div class="card-header" style={{ marginBottom: '-28px', fontWeight: 'bold', justifyContent: 'space-between', alignItems: 'center', display: 'flex' }}>
                          <span>Your Plan</span>
                          <span style={{ flex: '1', textAlign: 'center' }}> Subscription Amount</span>
                        </div>
                        <div class="card-body" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', marginTop: '-28px' }}>
                          <p class="card-title" style={{ fontSize: '21px', color: '#245C7F', fontWeight: 'bold' }} >
                            {planCheck}
                          </p>
                          <p class="card-title" style={{ fontSize: '21px', marginLeft: '105px', fontWeight: 'bold', color: 'rgb(36, 92, 127)' }}>$100.00  / User / Month</p>
                          <div type="button" style={{ marginTop: '-15px' }} data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => setAdduser(true)}>
                          </div>
                        </div>
                      </div> */}
                    <div className="card">
                      <div className="card-body">
                      <div className="row">
                        {/* Left Side: Plan Name */}
                        <div className="col-md-6">
                          <h5
                            className="card-text"
                            style={{
                              color: "#67748e",
                              display: "grid",
                              justifyContent: "flex-start",
                              fontWeight: "bold",
                            }}
                          >
                            Your Plan
                          </h5>
                          <p
                            style={{
                              display: "grid",
                              justifyContent: "flex-start",
                              color: "#245C7F",
                              fontWeight: "bold",
                            }}
                          >
                            {plan}
                          </p>
                        </div>

                        <div className="col-md-6">
                          <h5
                            style={{
                              display: "grid",
                              justifyContent: "flex-end",
                              fontWeight: "bold",
                              color: "#67748e",
                            }}
                          >
                            Subscription Amount
                          </h5>
                          <p
                            style={{
                              display: "grid",
                              justifyContent: "flex-end",
                              color: "#245C7F",
                              fontWeight: "bold",
                            }}
                          >
                            {`$ ${amount.toFixed(2)} / User / Month`}
                          </p>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-sm-6">
                    <div className="card">
                      <div className="card-body">
                        <div className="row justify-content-center">
                          <div className="col-md-9 ">
                            <div className="d-flex justify-content-between">
                              <p
                                className="card-title card-text"
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                  fontSize: "18px",
                                }}
                              >
                                Subscription Details{" "}
                              </p>
                              {amount === 0 ? (
                              /* 1. If amount is 0, show Free */
                              <span className="badge bg-success" style={{ alignContent: 'center' }}>
                                FREE
                              </span>
                            ) : planCheck === "Trial" ? (
                              /* 2. If it's a paid plan but still in Trial, show Trial Period */
                              <span className="badge bg-success" style={{ alignContent: 'center' }}>
                                TRIAL PERIOD
                              </span>
                            ) : (
                              /* 3. If it's paid and the trial is over, show Paid */
                              <span className="badge bg-success" style={{ alignContent: 'center' }}>
                                ACTIVE
                              </span>
                            )}
                            </div>
                            {/* {planCheck === 'Trial' ?
                                // companydata.plan === "Free" ?
                                <p className="card-text" style={{ color: 'rgb(36, 92, 127)', fontWeight: '' }}>15 Days Free Trial Period</p> : ''
                              } */}
                            <div className="d-flex justify-content-between mt-3">
                              <p
                                className="card-text "
                                style={{
                                  color: "#677483",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                }}
                              >
                                Start Date{" "}
                              </p>
                              <p
                                className="card-text text-end"
                                style={{
                                  color: "rgb(36, 92, 127)",
                                  fontWeight: "",
                                  textAlign: "right",
                                }}
                              >
                                {start_date ? Helper.DateNormal(start_date) : "N/A"}
                              </p>
                            </div>




                            
                            {/* <p className="card-text" style={{ color: 'rgb(36, 92, 127)', fontWeight: '' }}>Start Date : {start_date !== '' ? start_date : ''}</p> */}
                            {/* {planCheck === 'Trial' && <p className="card-text" style={{ color: 'rgb(36, 92, 127)', fontWeight: '' }}>Trial Period End Date : {trialEnd}</p>} */}
                            {trialDaysValue > 0 && (
                              <div className="d-flex justify-content-between">
                                <p
                                  className="card-text"
                                  style={{
                                    color: "#677483",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  }}
                                >
                                  Trial Period End Date{" "}
                                </p>
                                <p
                                  className="card-text text-end"
                                  style={{
                                    color: "rgb(36, 92, 127)",
                                    fontWeight: "",
                                    textAlign: "right",
                                  }}
                                >
                                  {amount > 0 && trialEnd ? Helper.DateNormal(trialEnd) : "-"}
                                </p>
                              </div>
                            )}
                            <div className="d-flex justify-content-between">
                              <p
                                className="card-text"
                                style={{
                                  color: "#677483",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                }}
                              >
                                Expiration Date{" "}
                              </p>
                              <p
                                className="card-text text-end"
                                style={{
                                  color: "rgb(36, 92, 127)",
                                  fontWeight: "",
                                  textAlign: "right",
                                }}
                              >
                                {amount > 0 && end_date ? Helper.DateNormal(end_date) : "--"}
                              </p>
                            </div>
                            <div className="d-flex justify-content-between">
                              <p
                                className="card-text"
                                style={{
                                  color: "#677483",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                }}
                              >
                                Renewal Date{" "}
                              </p>
                              <p
                                className="card-text text-end"
                                style={{
                                  color: "rgb(36, 92, 127)",
                                  fontWeight: "",
                                  textAlign: "right",
                                }}
                              >
                                {amount > 0 && renewal ? Helper.DateNormal(renewal) : "--"}
                              </p>
                            </div>
                            
                              




                            {/* <p className="card-text" style={{ color: 'rgb(36, 92, 127)', fontWeight: '' }}>Expiration Date : {end_date}</p>
                              <p className="card-text" style={{ color: 'rgb(36, 92, 127)', fontWeight: '' }}>Renewal Date : {renewal}</p> */}
                          </div>
                          {/* <div class="col-md-4"> */}
                          {/* <div class="text-end"> */}
                          {/* {planCheck === 'Trial' ?
                                  // companydata.plan === 'Free' ?
                                  <span className="position-absolute top-0 end-0 m-3 badge bg-success">15 Days Free Trial Period</span> :
                                  <span className="position-absolute top-0 end-0 m-3 badge bg-success">Active</span>
                                } */}
                          {/* </div> */}
                          {/* </div> */}
                        </div>
                        <div class="row justify-content-center mt-3">
                          {/* <div class="col-md-3">
                            {
                              planData.length>0 && planData[0].status === "cancelled"?"":

                                <button type="button" class="button btn btn-primary"  data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => handleChangeUser()}>
                                  Change User
                                </button> 
                            }
                          </div> */}
                          <div className="col-md-4">
                            {planData.length > 0 && planData[0].status === "cancelled" ? (
                              ""
                            ) : (
                              <button
                                type="button"
                                className="button btn btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#myModal"
                                onClick={() => {
                                  if (amount === 0) {
                                    // Action for Free Plan: Take them to the Upgrade flow
                                    setValue("upgrade");
                                    setUpgrade(true);
                                  } else {
                                    // Action for Paid/Annual Plan: Take them to Add Licenses flow
                                    setValue("addUser");
                                    setAdduser(true);
                                  }
                                }}
                              >
                                {amount === 0 ? "Upgrade" : "Add Licenses"}
                              </button>
                            )}
                          </div>
                          {/* {planData.length > 0 &&
                            planData[0].status === "cancelled" ? (
                            ""
                          ) : ( */}
                          {payment_intent_id !== '' &&
                          <div class="col-md-5">
                            <button
                              class="button btn btn-danger"
                              onClick={handleCancelSub}
                            >
                              Cancel your subscription
                            </button>
                          </div>
                          }
                          {/* )} */}
                        </div>
                        <div>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <p style={{ marginRight: "20px" }}>
                              {/* Number of Licenses: {totalUsersAllowed} */}
                              {t("Number of Licenses")}: {userallow}  
                            </p>
                            {/* <p>Number Of Users: {registeredUsersCount}</p> */}
                          </div>
                          <div
                            style={{
                              width: "100%",
                              backgroundColor: "#ddd",
                              overflow: "hidden",
                            }}
                          >
                            <div
                              style={{
                                width: `${registeredPercentage}%`,
                                height: "8px",
                                backgroundColor: "#245C7F",
                              }}
                            ></div>
                          </div>
                        </div>
                        {amount === 0 && (
                        <div className="row mt-3">
                          <div className="col-12 text-center">
                            <p
                              style={{
                                color: "#67748e",
                                fontSize: "14px", 
                                fontWeight: "500",
                                marginBottom: "0px"
                              }}
                            >
                              *NOTE* : IF THE FREE ORG IS NOT USED FOR 3 MONTHS, IT MAY BE REMOVED.
                            </p>
                          </div>
                        </div>
                      )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-sm-6">
                    <div class="card">
                      <div className=" mb-0">
                        <div class="card-body">
                          <div className="table-responsive p-0">
                            <MaterialTable
                              style={{
                                backgroundColor: "var(--bs-table-bg)",
                                borderBottomWidth: "1px",
                                boxShadow:
                                  "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                              }}
                              title={<h5 className="tc" style={{ paddingLeft: '10px' }}>{t("Payment History")}</h5>}
                              columns={[
                                {
                                  title: `${t("Invoice Date")}`,
                                  field: "created_at",
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Invoice Date")}
                                      </div>
                                      <div className="">
                                        {rowData.created_at ? Helper.DateNormal(rowData.created_at) : ""}
                                      </div>
                                    </>
                                  ),
                                },
                                {
                                  title: `${t("Transaction Id")}`,
                                  field: "payment_ref",
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Transaction Id")}
                                      </div>
                                      <div className="">
                                        {rowData.payment_ref}
                                      </div>
                                    </>
                                  ),
                                },
                                {
                                  title: `${t("Months")}`,
                                  field: "months",
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Months")}
                                      </div>
                                      <div className="">
                                        {/* { end_date =''?"": Math.max(0, end_date.getMonth() - rowData.created_at.getMonth() + (12 * (end_date.getFullYear() -  rowData.created_at.getFullYear())))} */}
                                        {rowData.months}
                                      </div>
                                    </>
                                  ),
                                },
                                {
                                  title: `${t("No. of Licenses")}`,
                                  field: "no_of_user",
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "right",
                                  },
                                  cellStyle: {
                                    textAlign: "right",
                                    fontSize: 12,
                                  },
                                  render: (rowData) => (
                                    <>
                                      <div
                                        className={`d-xl-none tc d-md-none d-lg-none`}
                                        style={{
                                          textAlign: rowData.isSmallScreen
                                            ? "left"
                                            : "right",
                                          fontSize: "12px",
                                          fontWeight: rowData.isSmallScreen
                                            ? "bold"
                                            : "",
                                        }}
                                      >
                                        {t("No of Users")}
                                      </div>
                                      <div
                                        className={`d-none d-xl-block d-lg-block text-right`}
                                        style={{
                                          textAlign: "right",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {rowData.no_of_user}
                                      </div>
                                    </>
                                  ),
                                },
                                {
                                  title: `${t("Total Amount")}`,
                                  field: "total",
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "right",
                                  },
                                  cellStyle: {
                                    textAlign: "right",
                                    fontSize: 12,
                                  },
                                  render: (rowData) => (
                                    <>
                                      <div
                                        className={`d-xl-none tc d-md-none d-lg-none`}
                                        style={{
                                          textAlign: rowData.isSmallScreen
                                            ? "left"
                                            : "right",
                                          fontSize: "12px",
                                          fontWeight: rowData.isSmallScreen
                                            ? "bold"
                                            : "",
                                        }}
                                      >
                                        {t("Total Amount")}
                                      </div>
                                      <div
                                        className={`d-none d-xl-block d-lg-block text-right`}
                                        style={{
                                          textAlign: "right",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {Helper.Amount(rowData.total_amount)}
                                      </div>
                                    </>
                                  ),
                                },
                                {
                                  title: `${t("Payment Method")}`,
                                  field: "payment_type",
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "right",
                                  },
                                  cellStyle: {
                                    textAlign: "right",
                                    fontSize: 12,
                                  },
                                  render: (rowData) => (
                                    <>
                                      <div
                                        className={`d-xl-none tc d-md-none d-lg-none`}
                                        style={{
                                          textAlign: rowData.isSmallScreen
                                            ? "left"
                                            : "right",
                                          fontSize: "12px",
                                          fontWeight: rowData.isSmallScreen
                                            ? "bold"
                                            : "",
                                        }}
                                      >
                                      {t("Payment Method")}
                                      </div>
                                      <div
                                        className={`d-none d-xl-block d-lg-block text-right`}
                                        style={{
                                          textAlign: "right",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {rowData.payment_type || rowData.payment_method || "N/A"}
                                      </div>
                                    </>
                                  ),
                                },
                                {
                                  title: `${t("Status")}`,
                                  field: "payment_status",
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  // cellStyle: {
                                  //   textAlign: "left",
                                  //   fontSize: 12
                                  // },
                                  render: (rowData) => {
                                  const isSuccess = rowData.payment_status?.toLowerCase() === "success";

                                  return (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Status")}
                                      </div>
                                      <div
                                        className={
                                          isSuccess 
                                            ? "badge bg-success" 
                                            : "badge bg-danger" 
                                        }
                                      >
                                        {rowData.payment_status}
                                      </div>
                                    </>
                                  );
                                },
                              }
                                // {
                                //   title: `${t("")}`,
                                //   field: "",

                                //   headerStyle: {
                                //     verticalAlign: "inherit",
                                //     fontWeight: "bold",
                                //     textAlign: "left",
                                //   },
                                //   cellStyle: {
                                //     textAlign: "left",
                                //     fontSize: 12,
                                //   },
                                //   render: (rowData) => (
                                //     <>
                                //       <div className="d-xl-none tc d-md-none d-lg-none">
                                //         {t("Status")}
                                //       </div>
                                //       <div>
                                //         <button className="badge btn btn-primary">
                                //           Download
                                //         </button>
                                //       </div>
                                //     </>
                                //   ),
                                // },
                              ]}
                              data={data}
                              options={{
                                emptyRowsWhenPaging: false,
                                search: false,
                                paging: true,
                                pageSize: 10, // make initial page size
                                pageSizeOptions: [10, 25, 50, 100],
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>{" "}
        </div>
      ) : (
        <ContentLoader
          viewBox="0 0 1000 550"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
          <circle cx="879" cy="123" r="11" />
          <circle cx="914" cy="123" r="11" />
          <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
          <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
          <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
          <circle cx="880" cy="184" r="11" />
          <circle cx="915" cy="184" r="11" />
          <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
          <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
          <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
          <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="242" r="11" />
          <circle cx="916" cy="242" r="11" />
          <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="303" r="11" />
          <circle cx="917" cy="303" r="11" />
          <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
          <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="363" r="11" />
          <circle cx="916" cy="363" r="11" />
          <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="424" r="11" />
          <circle cx="917" cy="424" r="11" />
          <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
          <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
          <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
          <circle cx="882" cy="484" r="11" />
          <circle cx="917" cy="484" r="11" />
          <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
          <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
          <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
          <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
          <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
          <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
          <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
        </ContentLoader>
      )}
    </>
  );
}

export default NewPaymentScreen;
